import React, { useState, useRef } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import { ScrollMenu, VisibilityContext } from 'react-horizontal-scrolling-menu';
import Box from '@mui/material/Box';

import {
  ButtonItem,
  cardData,
  CardItem,
  menu,
  FabStyles,
  Icons,
  DailerButton,
  PhoneNumberInput,
  ControlButton,
  remoteControls,
  BoxStyle,
  DailerIconButton,
  DailerGrid,
  remoteIconButtonsStyle,
  centerArrowRemoteicon
} from "./style";
import DotIcon from "@mui/icons-material/FiberManualRecord";
import { Avatar, Typography, useTheme } from "@mui/material";
import Button from "@mui/material/Button";
import Fab from "@mui/material/Fab";

import "./index.css";

const ConferencePage = () => {
  const [selectedMenu, setSelectedmenu] = useState<number>(0);
  const [displayTab, setDisplayTab] = useState<number>(1);
  const [micSelected, setMicselected] = useState<boolean>(false);
  const [videoSelected, setVideoselected] = useState<boolean>(false);
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [showMeetins, setShowMeetings] = useState<boolean>(true);
  const phoneInputRef = useRef(null);
  const theme = useTheme()
  const menuHandler = (ele: any, i: number) => {
    setSelectedmenu(i);
    setDisplayTab(ele.id);
  };
  const handlePhoneNumber = (value: number) => {
    if (phoneNumber.length < 11) {
      setPhoneNumber((phoneNumber) => phoneNumber + value.toString());
    }
  };
  const handleRemoveNumber = () => {
    setPhoneNumber((phoneNumber) => phoneNumber.slice(0, -1));
  };

  return (
    <Container maxWidth="md">
      <Grid container spacing={4} sx={{ mt: 1, mb: 4 }} className="Menu">
        {menu.map((ele, i) => {
          return (
            <Grid key={ele.id}>
              <ButtonItem
                sx={{ color: selectedMenu === i ? "#E7F011" : "" }}
                onClick={() => {
                  menuHandler(ele, i);
                }}
              >
                <>
                  {" "}
                  <DotIcon
                    fontSize="small"
                    sx={{
                      width: 10,
                      height: 10,
                      marginRight: "5px",
                      color: selectedMenu === i ? "inherit" : "#121212",
                    }}
                  />{" "}
                  {ele.name}{" "}
                </>
              </ButtonItem>
            </Grid>
          );
        })}
      </Grid>
      {displayTab === 1 ? (
        <>
          {showMeetins ? (
            <>

              {/* <div className="scrollmenu" /> */}
              <Box component="div" sx={BoxStyle}>
                <ScrollMenu >
                  {cardData.map((ele, i) => {
                    return (
                      <CardItem key={i} className="card">
                        <div className="card-element">
                          <Typography
                            sx={{ fontSize: 16, fontWeight: 400, paddingLeft: 2 }}
                            variant={"caption"}
                          >
                            {ele.time}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: 16,
                              fontWeight: 400,
                              paddingLeft: 2,
                              whiteSpace: "normal",
                              width: "90%",
                            }}
                            variant={"caption"}
                          >
                            {ele.content}
                          </Typography>
                          <div className="card-name">
                            <Typography
                              sx={{ fontSize: 16, fontWeight: 400 }}
                              variant={"caption"}
                            >
                              {ele.name}
                            </Typography>
                            <Button
                              sx={{
                                height: 40,
                                width: "40%",
                                background: "#2DAAE1",
                                borderRadius: "20px",
                                color: "#FFFFFF",
                                fontSize: 20,
                              }}
                            >
                              join
                            </Button>
                          </div>
                        </div>
                      </CardItem>
                    );
                  })}
                  {/* </div>
               */}
                </ScrollMenu>
              </Box>
            </>
          ) : (
            <Grid container spacing={2} sx={{ mt: 4 }}>
              <Grid sx={remoteIconButtonsStyle(theme)} xs={12} md={2}>
                {[1, 2, 3, 4].map((ele, i) => {
                  return <ControlButton key={i}>{ele}</ControlButton>;
                })}
              </Grid>
              <Grid container xs={12} md={8}>
                <Grid className="remote-div-left" justifyContent={"end"} xs={4} md={4}>
                  <IconButton>
                    <Avatar
                      sx={centerArrowRemoteicon(theme)}
                      src={Icons.ArrowLeftIcon}
                    />
                  </IconButton>

                </Grid>
                <Grid xs={4} md={4} className="remote-center-div">
                  <IconButton>
                    <Avatar
                      sx={centerArrowRemoteicon(theme)}
                      src={Icons.ArrowUpIcon}
                    />
                  </IconButton>

                  <IconButton><Icons.PanoramaFishEyeIcon sx={{ height: 130, width: 80 }} /></IconButton>

                  <IconButton><Avatar
                    sx={centerArrowRemoteicon(theme)}
                    src={Icons.ArrowDownIcon}
                  /></IconButton>

                </Grid>
                <Grid className="remote-div-right" xs={4} md={4}>
                  <IconButton>

                    <Avatar
                      sx={centerArrowRemoteicon(theme)}
                      src={Icons.ArrowRightIcon}
                    />
                  </IconButton>
                </Grid>
              </Grid>
              <Grid sx={remoteIconButtonsStyle(theme)} xs={12} md={2}>
                {remoteControls.map((ele, i) => {
                  return (
                    <IconButton key={i}
                      sx={{
                        backgroundColor: "#3E3E3E",
                        width: 102.5,
                        height: 102.5,
                        borderRadius: "15px",
                        fontSize: 14,
                        marginBottom: "15px",
                        display: "grid",
                        [theme.breakpoints.only('pp')]: {
                          width: 70,
                          height: 70,
                        }, [theme.breakpoints.down('sm')]: {
                          width: 70,
                          height: 70,
                        },

                      }}
                      aria-label="delete"
                    >
                      {i % 2 === 0 ? (
                        <Avatar
                          sx={{ width: 37, height: 37 }}
                          src={Icons.Plus}
                        />
                      ) : (
                        <Avatar sx={{ width: 37, he: 37 }} src={Icons.Minus} />
                      )}
                      {ele}
                    </IconButton>
                  );
                })}
              </Grid>
            </Grid>
          )}
        </>
      ) : (
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <Grid md={2}></Grid>
          <Grid container spacing={2} md={8} xs={12}>
            <Grid xs={12} container>
              <Grid xs={8} sx={{ textAlign: "center" }}>
                <PhoneNumberInput
                  disableUnderline={true}
                  value={phoneNumber}
                ></PhoneNumberInput>
              </Grid>
              <Grid xs={4}>
                <Avatar
                  onClick={() => handleRemoveNumber()}
                  sx={{ cursor: "pointer" }}
                  src={Icons.BackSpace}
                />
              </Grid>
            </Grid>
            <Grid sx={DailerGrid(theme)} xs={3}>
              <DailerButton onClick={() => handlePhoneNumber(1)}>
                1
              </DailerButton>
              <DailerButton onClick={() => handlePhoneNumber(4)}>
                4
              </DailerButton>
              <DailerButton onClick={() => handlePhoneNumber(7)}>
                7
              </DailerButton>
              <IconButton
                sx={DailerIconButton(theme)}
                aria-label="delete"
              >
                <Icons.LocalPhoneIcon fontSize="large" />
              </IconButton>
            </Grid>
            <Grid sx={DailerGrid(theme)} xs={3}>
              <DailerButton onClick={() => handlePhoneNumber(2)}>
                2
              </DailerButton>
              <DailerButton onClick={() => handlePhoneNumber(5)}>
                5
              </DailerButton>
              <DailerButton onClick={() => handlePhoneNumber(8)}>
                8
              </DailerButton>
              <DailerButton onClick={() => handlePhoneNumber(0)}>
                0
              </DailerButton>
            </Grid>
            <Grid sx={DailerGrid(theme)} xs={3}>
              <DailerButton onClick={() => handlePhoneNumber(3)}>
                3
              </DailerButton>
              <DailerButton onClick={() => handlePhoneNumber(6)}>
                6
              </DailerButton>
              <DailerButton onClick={() => handlePhoneNumber(9)}>
                9
              </DailerButton>
              <IconButton
                sx={{ ...DailerIconButton(theme), backgroundColor: "#FF0000" }}
                aria-label="delete"
              >
                <Icons.CallEndIcon fontSize="large" />
              </IconButton>
            </Grid>
          </Grid>
          <Grid md={2}></Grid>
        </Grid>
      )}

      <Grid container>
        <Grid xs={3} sm={3} md={3} lg={3} >
          <Fab
            onClick={() => setMicselected(!micSelected)}
            color="primary"
            aria-label="mic"
            sx={FabStyles[0]}
          >
            <Avatar src={micSelected ? Icons.Mic1 : Icons.Mic2} />
          </Fab>
        </Grid>
        <Grid xs={3} sm={3} md={3} lg={3} >
          <Fab
            onClick={() => setVideoselected(!videoSelected)}
            color="primary"
            aria-label="add"
            sx={FabStyles[1]}
          >
            <Avatar src={videoSelected ? Icons.Camera2 : Icons.Camera1} />
          </Fab>
        </Grid>
        <Grid xs={3} sm={3} md={3} lg={3} >
          <Fab color="primary" aria-label="add" sx={FabStyles[2]}>
            <Avatar src={Icons.Content} />
          </Fab>
        </Grid>
        <Grid xs={3} sm={3} md={3} lg={3} >
          <Fab
            color="primary"
            onClick={() => setShowMeetings(!showMeetins)}
            aria-label="add"
            sx={{
              ...FabStyles[3],
              backgroundColor: showMeetins ? "#3E3E3E" : "#2ED23E",
            }}
          >
            <Avatar src={Icons.CamControl} />
          </Fab>
        </Grid>




      </Grid>
    </Container>
  );
};

export default ConferencePage;
